<template>
  <v-container style="max-width: 1024px">
    <h1>Mon Projet en 3 étapes</h1>
    <br/>
    <h3><b>Etape 1:</b> Remplir le formulaire ci dessous</h3>
    <p style="">Avec les réponses aux questions suivantes, nos paysagistes pourront vous faire une proposition se rapprochant le plus de vos souhaits.
      <br/>
      En moyenne, nos clients mettent moins de <b>2 minutes</b> pour remplir le questionnaire.
    </p>
    <h3><b>Etape 2:</b> Procéder au réglement</h3>
    <p></p>
    <h3><b>Etape 3:</b> Recevoir le guide de prise des photos par email</h3>
    <p>
      Ce guide vous indiquera les informations à fournir et les différentes prises de vue de votre jardin à photographier pour que nos paysagistes puissent proposer le meilleur rendu possible de leurs créations.
    </p>
    <br/>
    <h2>Le formulaire</h2>
    <v-alert color="orange lighten-1" type="warning" border="left" v-if="e6 > 1">
      Rappel : vous pourrez décrire plus précisement votre projet à la question 7.
    </v-alert>
    <v-stepper v-model="e6" vertical>
      <StepType :step="1" :current="e6" v-model="form.type" @change="done(2)"/>

      <StepGoal :step="2" :current="e6" v-model="form.goal" @change="done(3)"/>

      <StepStyle :step="3" :current="e6" v-model="form.style" @change="done(4)"/>

      <StepArea :step="4" :current="e6" v-model="form.area" @change="done(5)"/>

      <StepSunshine :step="5" :current="e6" v-model="form.sunshine" @change="done(6)"/>

      <StepGround :step="6" :current="e6" v-model="form.ground" @change="done(7)"/>

      <StepMore :step="7" :current="e6" v-model="form.more" @change="done(8)"/>

      <StepHow :step="8" :current="e6" v-model="form.how" @change="done(9)"/>

      <v-stepper-step :complete="e6 > 9" :step="9" :editable="false" color="#FF696F">
        {{ optinTitle }}
      </v-stepper-step>

      <v-stepper-content :step="9">
        <span v-if="isPartner" @click="validate">
          <v-checkbox v-model="form.customerAgreement" :disabled="isWaiting">
            <template v-slot:label>
              <div>
                {{ optinMsg }}
              </div>
            </template>
          </v-checkbox>
        </span>
        <span v-else>
          {{ optinMsg }}
        </span>
        <br/>
        <v-btn v-if="!isWaiting" outlined color="#0b755f" @click="goShop" >Suivant</v-btn>
        <br/>
        <v-progress-linear v-if="isWaiting" indeterminate></v-progress-linear>
      </v-stepper-content>
    </v-stepper>
    <br/>
    <br/>
    <br/>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import StepType from '../components/project/Type'
import StepGoal from '../components/project/Goal'
import StepStyle from '../components/project/Style'
import StepArea from '../components/project/Area'
import StepSunshine from '../components/project/Sunshine'
import StepGround from '../components/project/Ground'
import StepMore from '../components/project/More'
import StepHow from '../components/project/How'

import { constantes } from '../store/app'

export default {
  components: { StepType, StepGoal, StepStyle, StepArea, StepSunshine, StepGround, StepMore, StepHow },
  data: () => ({
    e6: 1,
    form: {
      type: '',
      goal: '',
      style: '',
      area: '',
      sunshine: '',
      ground: '',
      more: '',
      partner: '',
      host: window.location.hostname,
      how: {
        from: '',
        more: ''
      },
      customerAgreement: false
    },
    isWaiting: false
  }),
  computed: {
    ...mapGetters('app', ['isPartner', 'host']),
    ...mapGetters('strapi', ['optinTitle', 'optinMsg'])
  },
  methods: {
    ...mapActions('app', ['updateHost']),
    done (step) {
      this.e6 = step
      if (step === 9) {
        if (this.host === constantes.HostHortusBox) {
          this.goShop()
        }
      }
    },
    goShop () {
      this.isWaiting = true
      this.form.partner = this.host
      localStorage.setItem('form-done', JSON.stringify(this.form))
      setTimeout(() => { 
        this.isWaiting = false
        this.$router.push('/shop')
      }, 2000)
      // setTimeout(() => { this.$router.push('/shop/107281518') }, 2000)
    },
    validate () {
      this.form.customerAgreement = true
      this.goShop()
    }
  },
  async mounted () {
    await this.updateHost()
    const options = {}
    this.$vuetify.goTo(0, options)
  }
}
</script>

<style scoped>
h1 {
  color: #0b755f;
}
h2 {
  color: #0b755f;
}
p {
  color:#3e524f;
}
@media (min-width: 1904px) {
  .container {
    max-width: 1185px!important;
  }
}
</style>